import { useState } from 'react';
import { Table, Button, Popconfirm } from 'antd';
import DayJS from 'dayjs';
import { ExclamationCircleFilled, CheckCircleFilled, EditFilled, DeleteFilled } from '@ant-design/icons';
import useSWR from 'swr';
import styled from 'styled-components';

import { deleteExpense } from '~/libs/requests';
import { moneyFormatter, nodesTitleResolver, useHandleSWR } from '~/libs/helpers';
import useGlobalState from '~/libs/context';
import { StyledTable } from './styles/StyledTable';

const itemsPerPage = 10;

const UploadsList = (props) => {
  const { year } = useGlobalState();
  const [ busyDeleting, setBusyDeleting ] = useState(false);
  const [ page, setPage ] = useState(1);
  const [ selectionType, setSelectionType ] = useState('checkbox');
  const { data: swrAccount, mutate: mutateAccount } = useSWR('/api/account');
  const { data: account, busy: busyAccount } = useHandleSWR(swrAccount, [], true);

  let settings = account?.settings;
  let categories = settings?.categories || [];
  let paymentMethods = settings?.paymentMethods || [];

  const { data: expenses, isValidating: busyLoading, mutate: mutateExpenses } = 
    useSWR(`/api/expenses?limit=${itemsPerPage}&skip=${(page - 1) * itemsPerPage}&year=${year}`);

  const onDelete = async (expenseId) => {
    setBusyDeleting(true);
    await deleteExpense(expenseId);
    mutateExpenses();
    //mutate(['/api/expenses', itemsPerPage, (page - 1) * itemsPerPage]);
    setBusyDeleting(false);
  }

  const onEditClick = (expense) => {
    if (props.onEditClick) {
      props.onEditClick(expense);
    }
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: x => ({ disabled: !x.isValid }),
  };

  const isExpenseValid = (expense) => {
    return expense.date && expense.amount && expense.categoryId;
  }

  const columns = [
    { title: '', dataIndex: 'isValid', key: 'isValid', width: 20,
      render: (_x, data) => isExpenseValid(data) ? <CheckCircleFilled style={{ fontSize: 24, color: '#2590ff' }} /> : 
        <ExclamationCircleFilled style={{ fontSize: 24, color: '#f94d4f' }} />,
    },
    { title: 'Date', dataIndex: 'date', key: 'date', width: 80,
      render: x => x ? DayJS(new Date(x)).format('MM/DD') : <i style={{ color: '#f94d4f' }}>Missing</i> },
    { title: 'Details', dataIndex: 'details', key: 'details',
      render: x => x ? x : '-' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount',
      render: x => x ? moneyFormatter(x) : <i style={{ color: '#f94d4f' }}>Missing</i> },
    { title: 'Category', dataIndex: 'categoryId', key: 'categoryId',
      render: x => x ? nodesTitleResolver(x, categories) : <i style={{ color: '#f94d4f' }}>Missing</i> },
    { title: 'Action', width: 83, key: 'action', render: (text, expense) => (
      <span style={{ marginRight: -10 }}>
        <Button type="primary" icon={<EditFilled />} style={{ marginRight: 5 }}
          onClick={() => onEditClick(expense)}></Button>
        <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => onDelete(expense._id)}>
          <Button danger icon={<DeleteFilled />}></Button>
        </Popconfirm>
      </span>
    )}
  ];

  return (
    <StyledTable rowKey='_id' size='small'
      //rowSelection={{ type: 'checkbox', ...rowSelection }}
      onRow={expense => { return { onDoubleClick: () => onEditClick(expense) } }}
      columns={columns}
      dataSource={expenses ? expenses.data : null}
      pagination={{ 
        current: page,
        defaultPageSize: itemsPerPage,
        total: expenses ? expenses.total : 0,
        onChange: (p) => setPage(p)
      }}
      loading={busyLoading || busyDeleting} 
    />
  );
}

export default UploadsList;